module.exports = __webpack_public_path__ + "static/media/icofirmaya_driver_gris.9d981308.svg";